/**
 * Created by rathompson on 6/1/22
 * File: SupportContactModal
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import {
  Body,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  ModalHeader,
} from '@panwds/react-ui'
import { LABEL_SUPPORT_CONTACT, BUTTON_CLOSE } from '../../../common/constants/LabelConstants'

const ViewIdentityModal = ({ closeModal, isOpen, tenant }) => {

  return (
    <Modal
      size='sm'
      onClose={closeModal}
      {...{ isOpen }}
    >
      <div className='header-wrapper'>
        <ModalHeader title={LABEL_SUPPORT_CONTACT}/>
      </div>
      <ModalBody addClassName='tw-truncate'>
        <div style={{ whiteSpace: 'break-spaces', wordBreak: 'break-word' }}>
          <Body>{tenant?.support_contact}</Body>
        </div>
      </ModalBody>
      <ModalFooter>
        <ModalCloseButton
          appearance='secondary'
        >{BUTTON_CLOSE}</ModalCloseButton>
      </ModalFooter>
    </Modal>
  )
}

export default ViewIdentityModal
